"use client";
import * as React from "react";
const SvgAssignmentOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.56 12.6h6.22v1.8H3.56zm0-3.6h8.88v1.8H3.56zm0-3.6h8.88v1.8H3.56zm10.66-3.6h-3.71C10.13.76 9.16 0 8 0S5.87.76 5.5 1.8H1.77q-.19-.01-.36.04A1.8 1.8 0 0 0 .14 2.9a2 2 0 0 0-.14.7v12.6a2 2 0 0 0 .52 1.28q.38.37.9.5l.36.02h12.44A1.8 1.8 0 0 0 16 16.2V3.6c0-.99-.8-1.8-1.78-1.8M8 1.57a.68.68 0 0 1 0 1.36.68.68 0 0 1 0-1.36m6.22 14.63H1.78V3.6h12.44z" }));
export {
  SvgAssignmentOutlined as default
};
